import { Reporter } from '../reporter/Reporter'

type props = { text?: string }

export const PulseOximeter: React.FC<props> = ({ text }) => (
  <div className={'affiliate'}>
    <Reporter
      text={text}
      defaultText={'Pulse oximeter'}
      link="https://www.amazon.com/Zacurate-Fingertip-Oximeter-Saturation-Batteries/dp/B06Y2FFQB9"
    />
  </div>
)

export const SecondsAppIOS: React.FC<props> = ({ text }) => (
  <div className={'affiliate'}>
    <Reporter
      text={text}
      defaultText={'Seconds'}
      link="https://apps.apple.com/us/app/seconds-pro-interval-timer/id363978811"
    />
  </div>
)

export const SecondsAppAndroid: React.FC<props> = ({ text }) => (
  <div className={'affiliate'}>
    <Reporter
      text={text}
      defaultText={'Seconds'}
      link="https://play.google.com/store/apps/details?id=com.runloop.seconds.free&hl=en_US&gl=US"
    />
  </div>
)
